<div class="toolbar-fixed-layout">
    <div class="toolbar second-level-toolbar flex flex-row justify-between items-center">
        <div class="grid-toolbar-buttons-group-container flex flex-col justify-center items-start">

            <div class="flex flex-row justify-start items-center">
                <button mat-button class="link-button" (click)="AddRecord()"
                        particleAnalytics
                        analyticsCategory="entity-transactions-content"
                        analyticsAction="add-section"
                >Add New Record
                </button>
                <div class="toolbar-separator" style="height: 15px!important;"></div>
                <button mat-button class="link-button" (click)="showEntityChildrensDialog()"
                        particleAnalytics
                        analyticsCategory="entity-transactions-content"
                        analyticsAction="add-section"
                >Show Children
                </button>
                <span *ngIf="childrenFilterEnabled" class="m-l-5 flex flex-row justify-start items-center"> (<a
                        (click)="clearChildrenFilter()" class="pointer link-color">Default</a>)</span>
                <div class="toolbar-separator" style="height: 15px!important;"></div>
                <div class="button-container flex flex-row justify-start items-center">
                    <particle-grid-apply-filter [filterId]="sourceType"
                                                [endpointName]="'Dac6Api'"
                                                [invalidateSubject]="invalidateSubject">
                    </particle-grid-apply-filter>
                </div>
                <!--<div class="toolbar-separator" style="height: 15px!important;"></div>
                <button mat-button class="link-button" (click)="Add()"
                        particleAnalytics
                        analyticsCategory="entity-transactions-content"
                        analyticsAction="add-section"
                >Export
                </button>-->
            </div>
        </div>

    </div>
    <mat-sidenav-container style="background-color: white;">
        <div class="simple-scroll flex flex-row justify-center items-start full-grow-no-shrink-no-basis">
            <div class="content pos-relative max-height flex flex-col full-grow-no-shrink-no-basis">
                <div class="keno-grid-container">
                    <particle-virtual-grid [sourceKey]="data.input['sourceType']"
                                           [invalidateSubject]="invalidateSubject"
                                           (valueChanged)="onGridCellValueChange($event)"
                    >
                    </particle-virtual-grid>
                </div>
            </div>
        </div>
    </mat-sidenav-container>
</div>
